import { auth, googleProvider, signInWithPopup } from '../../helpers/firebaseConfig';

export const googleSignInHelper = async () => {
  try {
    if (auth.currentUser) {
      console.log("User already signed in:", auth.currentUser);
      const token = await auth.currentUser.getIdToken();
      console.log('token',token)
      return {
        isAlreadyUser: true,
        user: auth.currentUser,
        token,
      };
    }

    console.log('Initiating Google sign-in...');
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    const token = await user.getIdToken();
    console.log('firebase token',token)
    return {
      isAlreadyUser: false,
      user,
      token,
    };
  } catch (error) {
    console.error("Error during Google sign-in:", error.message);
    return {
      error: true,
      message: error.message,
    };
  }
};
